import React from 'react';
import {
  ChakraProvider,
  Box,
  VStack,
  theme,
} from '@chakra-ui/react';
import { Logo } from './Logo';

import Navbar from './components/navbar.js';
import FullImgHero from './components/hero-fullimg.js';
import Hero from './components/hero.js';
import Features from './components/features.js';
import Projects from './components/projects.js';
import Renderingstills from './components/renderings.js';
import Handdrawings from './components/handdrawings.js';
import Footer from './components/footer.js';
import Animations from './components/animations.js';


function App() {
  return (
    <ChakraProvider theme={theme}>
      <Navbar />
      <FullImgHero/>
      {/* <Hero /> */}
      <Features />
      {/* spinning pinwheel */}
      {/* <Box textAlign="center" fontSize="xl"
      p='24'
      // minH="100vh"
      >         
          <VStack spacing={8}>
            <Logo h="40vmin" pointerEvents="none" />
          </VStack>
      </Box> */}
      
      <Projects/>
      {/* <Animations /> */}
      <Renderingstills />
      <Handdrawings/>
      <Footer />
    </ChakraProvider>
  );
}

export default App;
